import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gift_info_area" }
const _hoisted_2 = { class: "gift_info_box" }
const _hoisted_3 = { class: "gift_info" }
const _hoisted_4 = { class: "store" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 사용 취소는 쿠폰을 사용한 가맹점에서만 가능합니다. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 사용 취소를 원하시면 점원에게 휴대폰을 보여주세요. ")
], -1)
const _hoisted_7 = { class: "btn_area" }
const _hoisted_8 = {
  key: 1,
  class: "barcode_area"
}
const _hoisted_9 = {
  key: 0,
  class: "thumb_barcode"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "barcode_img",
  alt: "바코드"
}, null, -1)
const _hoisted_11 = { class: "barcode_number" }
const _hoisted_12 = {
  key: 1,
  class: "btn_area"
}
const _hoisted_13 = {
  key: 2,
  class: "refuse_area"
}
const _hoisted_14 = { class: "desc" }
const _hoisted_15 = {
  key: 3,
  class: "refund_area"
}
const _hoisted_16 = { class: "btn_area" }
const _hoisted_17 = {
  key: 4,
  class: "passed_area"
}
const _hoisted_18 = { class: "barcode_area" }
const _hoisted_19 = {
  key: 0,
  class: "thumb_barcode"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "barcode_img",
  alt: "바코드"
}, null, -1)
const _hoisted_21 = { class: "barcode_number" }
const _hoisted_22 = { class: "btn_area" }
const _hoisted_23 = {
  key: 5,
  class: "passed_area"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "desc" }, "환불 및 연장이 불가한 상품입니다.", -1)
const _hoisted_25 = {
  key: 6,
  class: "passed_area"
}
const _hoisted_26 = { class: "btn_area" }
const _hoisted_27 = {
  key: 7,
  class: "passed_area"
}
const _hoisted_28 = { class: "btn_area" }
const _hoisted_29 = {
  key: 0,
  class: "gift_payment_detail"
}
const _hoisted_30 = { class: "payment_detail_list" }
const _hoisted_31 = { class: "payment_list" }
const _hoisted_32 = /*#__PURE__*/_createVNode("dt", { class: "payment_tit" }, "승인 일시", -1)
const _hoisted_33 = { class: "payment_txt" }
const _hoisted_34 = { class: "payment_list" }
const _hoisted_35 = /*#__PURE__*/_createVNode("dt", { class: "payment_tit" }, "승인 번호", -1)
const _hoisted_36 = { class: "payment_txt" }
const _hoisted_37 = { class: "payment_list" }
const _hoisted_38 = /*#__PURE__*/_createVNode("dt", { class: "payment_tit" }, "결제 수단", -1)
const _hoisted_39 = { class: "payment_txt" }
const _hoisted_40 = { class: "payment_list" }
const _hoisted_41 = /*#__PURE__*/_createVNode("dt", { class: "payment_tit" }, "사용처", -1)
const _hoisted_42 = { class: "payment_txt" }
const _hoisted_43 = { class: "payment_list" }
const _hoisted_44 = /*#__PURE__*/_createVNode("dt", { class: "payment_tit" }, "문의처", -1)
const _hoisted_45 = { class: "payment_txt" }
const _hoisted_46 = {
  key: 0,
  class: "layer_pop toast"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("p", { class: "text" }, "교환권 번호가 복사되었습니다.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.product.brandName), 1),
          _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.product.productName), 1)
        ]),
        (_ctx.ticket.isUsed)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: ["cancle_area", {'is_show': _ctx.showTicket}]
            }, [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _createVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTicket && _ctx.toggleTicket(...args))),
                  type: "button",
                  class: "btn btn_cancle"
                }, "사용취소")
              ])
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.canShowTicket)
          ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_8, [
              (_ctx.ticket.isBarcodeType)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _hoisted_10
                  ]))
                : _createCommentVNode("", true),
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.ticket.ticketPinNumber), 1),
              _createVNode("button", {
                type: "button",
                class: "btn_copy",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyClipboard(_ctx.ticket.ticketPinNumber)))
              }, "복사"),
              (_ctx.ticket.validityExtendable)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('toggleExtendingPopup'))),
                      type: "button",
                      class: "btn btn_default"
                    }, "유효기간 연장")
                  ]))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, _ctx.showTicket]
            ])
          : _createCommentVNode("", true),
        (_ctx.ticket.isRejected)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("p", _hoisted_14, "선물 받기를 거절한 상품입니다. (" + _toDisplayString(_ctx.ticket.rejectedDate) + ")", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.ticket.isRefunded)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moveToRefundingHistory && _ctx.moveToRefundingHistory(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "환불 완료 내역 보기")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ticket.isExpired && _ctx.ticket.isRefundable)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                (_ctx.ticket.isBarcodeType)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _hoisted_20
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.ticket.ticketPinNumber), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn_copy",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyClipboard(_ctx.ticket.ticketPinNumber)))
                }, "복사")
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyForRefund && _ctx.applyForRefund(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "환불 신청")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ticket.isExpired && !_ctx.ticket.isRefundable)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _hoisted_24
            ]))
          : _createCommentVNode("", true),
        (_ctx.ticket.isRefunding)
          ? (_openBlock(), _createBlock("div", _hoisted_25, [
              _createVNode("div", _hoisted_26, [
                _createVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.moveToRefundingHistory && _ctx.moveToRefundingHistory(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "환불 대기 내역 보기")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ticket.isRefundFailed)
          ? (_openBlock(), _createBlock("div", _hoisted_27, [
              _createVNode("div", _hoisted_28, [
                _createVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.moveToRefundingHistory && _ctx.moveToRefundingHistory(...args))),
                  type: "button",
                  class: "btn btn_default"
                }, "환불 실패 내역 보기")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.ticket.isUsed)
        ? (_openBlock(), _createBlock("div", _hoisted_29, [
            _createVNode("dl", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode("dd", _hoisted_33, _toDisplayString(_ctx.approval.approvalYmdt), 1)
              ]),
              _createVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode("dd", _hoisted_36, _toDisplayString(_ctx.approval.approvalNo), 1)
              ]),
              _createVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode("dd", _hoisted_39, _toDisplayString(_ctx.approval.paymentMethod), 1)
              ]),
              _createVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode("dd", _hoisted_42, _toDisplayString(_ctx.approval.usedStore), 1)
              ]),
              _createVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode("dd", _hoisted_45, _toDisplayString(_ctx.approval.approvalInquiry), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.copyAlert)
      ? (_openBlock(), _createBlock("div", _hoisted_46, [
          _hoisted_47
        ]))
      : _createCommentVNode("", true)
  ], 64))
}